import { useState } from 'react';
import { Mousewheel, Navigation, Pagination } from 'swiper/modules';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import { hexToRgb } from '../../../common/hexToRgb';
import { useColorFuncs } from '../../../hooks/responsive/useColorFuncs';
import { updateColor } from '../../../js/colorHandling';
import './Color.css';

export function Color({ colors }) {
  const slides = colors;
  const [swiperRef, setSwiperRef] = useState(null);
  const [isChange, setIsChange] = useState(false);
  const [activeIndex, setActiveIndex] = useState(undefined);
  const { handleClick } = useColorFuncs(swiperRef);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <SwiperComponent
        direction={'vertical'}
        slidesPerView={12}
        ref={swiperRef}
        initialSlide={slides.length / 2}
        onSwiper={(swiper) => {
          setIsChange(false);
          setSwiperRef(swiper);
        }}
        onActiveIndexChange={(swiper) => {
          setActiveIndex(swiper.activeIndex);
          updateColor(hexToRgb(slides[swiper.realIndex]));
          if (isChange) {
            const temp = hexToRgb(slides[swiper.realIndex]);
            updateColor(temp);
          }
          setIsChange(true);
        }}
        centeredSlides={true}
        loop={true}
        mousewheel={true}
        watchSlidesProgress={true}
        onProgress={(swiper) => {
          const slides = swiper.slides;
          for (const slide of slides) {
            const progress = slide.progress;
            const roundedProgress = Math.round(progress);
            if (roundedProgress === 0) {
              slide.style.transform = `rotate(${0}deg)`;
            } else if (roundedProgress < 0) {
              slide.style.transform = `rotate(${10}deg)`;
            } else {
              slide.style.transform = `rotate(${-10}deg)`;
            }
          }
        }}
        onSetTransition={(swiper, duration) => {
          for (const slide of swiper.slides) {
            slide.style.transitionDuration = `${duration}ms`;
          }
        }}
        modules={[Pagination, Navigation, Mousewheel]}
        className="mySwiper colorSwiper"
        style={{ height: '100%' }}
      >
        {slides?.map((item, index) => (
          <SwiperSlide
            key={index}
            onClick={() => {
              setActiveIndex(index);
              handleClick(item, index);
            }}
          >
            <div
              style={{
                background:
                  'rgba(' +
                  item?.rgba[0] +
                  ',' +
                  item?.rgba[1] +
                  ',' +
                  item?.rgba[2] +
                  ',' +
                  item?.rgba[3] +
                  ')',
                margin: 'auto',
              }}
              className={`colorItem ${activeIndex === index ? 'active-color' : ''}`}
            ></div>
          </SwiperSlide>
        ))}
      </SwiperComponent>
    </div>
  );
}
